<template>
	<div class="watch-options-configs">
		<spinner v-if="configs.loading"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<div class="idi-table configs">
				<div class="idi-header">
					<div class="idi-cell">{{ $t('labels.general.name') }}</div>
					<div class="idi-cell">{{ $t('labels.general.value') }}</div>
				</div>
				<div class="idi-row" v-for="(config, index) in configs.data" :key="config.name">
					<div class="idi-cell">{{ translate(config.name) }}</div>
					<div class="idi-cell">
						<input type="checkbox" v-if="typeField(config.name) == 'bool'" v-model="configs.data[index].value" :name="`configs_${config.name}`" :true-value="'true'" :false-value="'false'" />
						<input-text v-else v-model="configs.data[index].value" :name="`configs_${config.name}`" rules="required"/>
					</div>
				</div>
			</div>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</div>
</template>

<script>
//import { debounce } from 'debounce'
import ApiCollection from '@/classes/api/ApiCollection'
import FormObject from '@/classes/api/FormObject'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			name: 'watch options configs',
			configs: new ApiCollection(),
			form: new FormObject(),
			configsDataClone: {},
			savingConfigs: new Set(),
			savingConfigsTrigger: 0,
			//debouncedEditConfig: null
		}
	},
	computed: {
		loading () {
			let temp = this.savingConfigsTrigger
			return this.savingConfigs.size > 0
		}
	},
	watch: {
		loading: {
			handler (value) {
				this.form.loading = value
			},
			immediate: true
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.editConfigs()
				})
		},
		getConfigs () {
			this.configs.loading = true
			this.$api.patients.configurations.get(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info(this.name, 'patients.configurations.getAll OK', response)()
					this.configs.data = response.body.reduce((acc, val) => { acc[val.name] = val; return acc }, {})
					this.configsDataClone = JSON.parse(JSON.stringify(this.configs.data))
					//dynamic watch
					/*for (let prop in this.configs.data) {
						this.$watch('configs.data.' + this.configs.data[prop].name, {
							handler (val) {
								this.debouncedEditConfig(val.name, val.value)
							},
							deep: true
						})
					}*/
				}).catch(error => {
					this.$log.error(this.name, 'patients.configurations.getAll ERROR', error)()
					this.configs.error = error
				}).finally(() => {
					this.configs.loading = false
				})
		},
		editConfig (name, value) {
			const tmpValue = value+''
			const model = { name, value: tmpValue }
			this.savingConfigs.add(name)
			this.savingConfigsTrigger++
			this.$api.patients.configurations.edit(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info(this.name, 'patients.configurations.edit OK', response)()
				}).catch(error => {
					this.$log.error(this.name, 'patients.configurations.edit ERROR', error)()
				}).finally(() => {
					this.savingConfigs.delete(name)
					this.savingConfigsTrigger++
				})
		},
		editConfigs () {
			for (let prop in this.configs.data) {
				if (this.configs.data[prop].value != this.configsDataClone[prop].value) {
					this.editConfig(this.configs.data[prop].name, this.configs.data[prop].value)
				}
			}
			this.configsDataClone = JSON.parse(JSON.stringify(this.configs.data))
		},
		translate (name) {
			switch (name) {
				case 'sos_phone':
					return this.$t('labels.general.sos_phone')
				case 'sync_alert':
					return this.$t('labels.general.sync_interval_alert')
				case 'sync_normal':
					return this.$t('labels.general.sync_interval_normal')
				case 'timezone':
					return this.$t('labels.general.timezone')
				case 'offline_timer':
					return this.$t('labels.general.offline_timer')
				case 'timeout_sos_state':
					return this.$t('labels.general.timeout_sos_state')
				case 'timeout_turn_off_screen':
					return this.$t('labels.general.timeout_turn_off_screen')
				case 'fall_detection':
					return this.$t('labels.general.fall_detection')
				default:
					return ''
			}
		},
		typeField (fieldName) {
			if (['fall_detection'].includes(fieldName)) {
				return 'bool'
			}
			return 'string'
		}
	},
	mounted () {
		//this.debouncedEditConfig = debounce(this.editConfig, 500)
		this.getConfigs()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/options/WatchOptionsConfigs.vue